var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "UserLogout",
    "options": {
        "objc_class_prefix": "UserLogout",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": []
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/logout/logout.pb.js